import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import store from './store'
import './registerServiceWorker'

Vue.config.productionTip = false
function createApp() {
  new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App),
  }).$mount('#app')
}

try {
  if (document.cookie.includes('APAUTH')) {
    fetch('/api/me').then((x) =>
      x.json().then((user) => {
        store.commit('setUser', user)
        createApp()
      })
    )
  } else {
    createApp()
  }
} catch {
  createApp()
}
